'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamSelector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StreamBox = require('./StreamBox');

var _StreamBox2 = _interopRequireDefault(_StreamBox);

var _Tooltip = require('../../shared/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _g11n = require('../../shared/g11n');

var _g11n2 = _interopRequireDefault(_g11n);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _Log = require('../../shared/Log');

var _style3 = require('../../Video/style.css');

var _PlayPauseContainer = require('../PlayPause/PlayPauseContainer');

var _hudlUniformUiComponents = require('hudl-uniform-ui-components');

var _icon = require('../../shared/styles/icon.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StreamSelector = exports.StreamSelector = function (_Component) {
  _inherits(StreamSelector, _Component);

  function StreamSelector(props) {
    _classCallCheck(this, StreamSelector);

    var _this = _possibleConstructorReturn(this, (StreamSelector.__proto__ || Object.getPrototypeOf(StreamSelector)).call(this, props));

    _this.toggleMenuOpenState = function () {
      var shouldSkipManipulatingPlayState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var opened = !_this.state.opened;
      (0, _Log.log)(_this.props.playerId, 'StreamMenu' + (opened ? 'Opened' : 'Closed'));

      // only manipulate state if the arg is true
      // this means the user is not clicking on the video
      // or they are opening the selector
      if (shouldSkipManipulatingPlayState === false) {
        opened ? _this.props.pauseAction() : _this.props.playAction();
      }

      _this.props.setContextMenu(opened);
      _this.setState({ opened: opened });
    };

    _this.state = {
      opened: false
    };
    return _this;
  }

  _createClass(StreamSelector, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.opened && nextProps.contextMenuOpen !== this.props.contextMenuOpen) {
        this.setState({
          opened: false
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.opened !== this.state.opened || nextProps.streams !== this.props.streams || nextProps.selectedStreamId !== this.props.selectedStreamId || nextProps.contextMenuOpen !== this.props.contextMenuOpen;
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(e) {
      // only should respond if the settings menu is currently visible
      if (!this.state.opened) {
        return;
      }
      // We do not want to trigger the play/pause logic if you are clicking on the video
      // itself or the play button. The reason is because the video handles play/pause logic.
      // If both places do it, we basically just flicker play/pause fast.
      var clickedOnVideo = e.target.className === _style3.videoOverlay;
      var clickedOnPlayButton = false;

      var target = e.target;
      while (target !== document.body) {
        if (clickedOnPlayButton === false) {
          // IE11 has dataset as null sometimes
          clickedOnPlayButton = target.dataset ? target.dataset.hudlElement === _PlayPauseContainer.dataHudlElement : false;
        }
        // parentNode for IE11
        target = target.parentElement || target.parentNode;
      }

      this.toggleMenuOpenState(clickedOnPlayButton || clickedOnVideo);
    }
  }, {
    key: 'renderStreams',
    value: function renderStreams() {
      var _this2 = this;

      return this.props.streams.map(function (s, i) {
        return _react2.default.createElement(_StreamBox2.default, {
          currentTimeMs: _this2.props.currentTimeMs,
          selectStream: _this2.props.selectStream,
          streamId: s.id,
          name: s.name,
          index: i,
          thumbnailUrl: s.thumbnailUrl,
          selected: s.id === _this2.props.selectedStreamId,
          key: s.id + '-angleBox'
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var stream = this.props.streams.find(function (s) {
        return s.id === _this3.props.selectedStreamId;
      });

      var angleIndex = this.props.streams.indexOf(stream) + 1;
      var angleIconType = 'angle' + angleIndex;

      return _react2.default.createElement(
        'div',
        {
          onClick: function onClick() {
            return _this3.toggleMenuOpenState();
          },
          className: _style2.default.angleSelector,
          'data-hudl-element': 'vi-controls-angleselector'
        },
        this.state.opened ? _react2.default.createElement(
          'div',
          { className: _style2.default.angleSelectorBoxInner },
          this.renderStreams()
        ) : null,
        _react2.default.createElement(
          _Tooltip2.default,
          { title: (0, _g11n2.default)('vi.player.controls.angle_switcher') },
          _react2.default.createElement(
            'div',
            { className: _icon.iconStyle },
            _react2.default.createElement(_hudlUniformUiComponents.Icon, { type: angleIconType, size: 'medium' })
          )
        )
      );
    }
  }]);

  return StreamSelector;
}(_react.Component);

StreamSelector.propTypes = {
  streams: _propTypes2.default.array,
  currentTimeMs: _propTypes2.default.number.isRequired,
  contextMenuOpen: _propTypes2.default.bool.isRequired,
  selectedStreamId: _propTypes2.default.string.isRequired,
  playerId: _propTypes2.default.string.isRequired,
  pauseAction: _propTypes2.default.func.isRequired,
  playAction: _propTypes2.default.func.isRequired,
  selectStream: _propTypes2.default.func.isRequired,
  setContextMenu: _propTypes2.default.func.isRequired
};
StreamSelector.defaultProps = {
  selectedStreamId: '0'
};
exports.default = (0, _reactOnclickoutside2.default)(StreamSelector);